/**
 * Shared parsing utilities used across bank statement parsers and the CSV import.
 */

/**
 * Read an amount cell as a signed number (0 when unreadable).
 *
 * Strips thousands separators (western 123,456.00 and Indian lakh grouping 1,23,456.00),
 * a currency symbol or code (₹, Rs., INR, $), and a Dr/Cr suffix. A Dr suffix or
 * parentheses make the value negative; "-1,500.00" stays negative.
 */
export function parseSignedAmount(cell: unknown): number {
  if (cell === null || cell === undefined || cell === "") return 0
  if (typeof cell === "number") return Number.isNaN(cell) ? 0 : cell
  let s = String(cell).trim()
  let negative = false
  if (/^\(.*\)$/.test(s)) {
    negative = true
    s = s.slice(1, -1)
  }
  const mark = s.match(/\s*\(?(dr|cr)\.?\)?$/i)
  if (mark) {
    if (mark[1].toLowerCase() === "dr") negative = true
    s = s.slice(0, mark.index)
  }
  s = s.replace(/(₹|\bRs\.?|\bINR\b|\$)/gi, "").replace(/[,\s]/g, "")
  const n = Number.parseFloat(s)
  if (Number.isNaN(n)) return 0
  return negative ? -Math.abs(n) : n
}

/** The same cell as a positive number: statement columns already say debit or credit. */
export function parseAmount(cell: unknown): number {
  return Math.abs(parseSignedAmount(cell))
}
